/** @jsx jsx */
import { useEffect, useState } from 'react'
import { Box, Heading, jsx, Text } from 'theme-ui'
import ListingCardImage from '~/components/Listing/Card/Image'
import ProductLink from '~/components/Product/Link'
import { useCanClub } from '~/hooks/components/use-can-club'
import { toUsdCurrency } from '~/utils/formatters'
import { getClubDiscountedPrice } from '~/utils/subscriptions'

const ListingCardSimple = ({
  callout,
  canQuantity,
  hoverImage,
  mainImage,
  name,
  price,
  slug,
  slugUrl,
}) => {
  const { clubDiscount } = useCanClub()
  const [displayPrice, setDisplayPrice] = useState(price)

  useEffect(() => {
    if (clubDiscount && displayPrice === price) {
      const discountedPrice = getClubDiscountedPrice(clubDiscount, price)
      setDisplayPrice(discountedPrice)
    }
  }, [clubDiscount, displayPrice, price])

  return (
    <Box
      mx="auto"
      sx={{
        maxWidth: '475px',
        textAlign: 'left',
        width: '100%',
      }}
    >
      <ListingCardImage
        callout={callout}
        hoverImage={hoverImage}
        mainImage={mainImage}
        name={name}
        slug={slug}
        slugUrl={slugUrl}
      />
      <Box mt={2} px={1}>
        <Heading as="h2" variant="title4" mb={price && '4px'}>
          <ProductLink
            slug={slug}
            slugUrl={slugUrl}
            sx={{
              color: 'black',
              display: 'block',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            {name}
          </ProductLink>
        </Heading>
        {price && (
          <Text as="p" variant="body2" mb={2} sx={{ color: 'greyDark' }}>
            {canQuantity &&
              `${canQuantity} cans / ${toUsdCurrency(displayPrice)}`}
            {!canQuantity && toUsdCurrency(displayPrice)}
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default ListingCardSimple
